import { useContext, useState } from "react";

import { AiFillHome, AiFillPieChart } from "react-icons/ai";
import { FaUsers, FaBuilding, FaWifi } from "react-icons/fa";
import { TfiAngleLeft } from "react-icons/tfi";

import { AiFillProduct } from "react-icons/ai";
import { IoLogOutSharp, IoSettings } from "react-icons/io5";
import { BiSolidHelpCircle } from "react-icons/bi";
import { IoMdNotifications } from "react-icons/io";

import Cookies from "js-cookie";

import logo from "../../assets/images/logo.png";
import "./style.css";

const Sidebar = () => {
	//   const { sidebarOpen, setSidebarOpen, setUserInfo } =
	//     useContext(DasboardContext);

	const [redirect, setRedirect] = useState(false);

	//   const logOut = () => {
	//     Cookies.remove("token");
	//     // fetch("https://app.vivasmartcare.com/api/logout", {
	//     //   credentials: "include",
	//     //   method: "POST",
	//     // });
	//     setUserInfo(null);
	//     setRedirect(true);
	//   };

	//   if (redirect) {
	//     return <Navigate to={"/login"} />;
	//   }

	return (
		// <div className={`sidebar-wrapper ${sidebarOpen ? "" : "close"}`}>
		<div className="sidebar-wrapper">
			<div className="logo-wrapper">
				<img src={logo} alt="logo" />
				{/* <TfiAngleLeft onClick={() => setSidebarOpen(true)} /> */}
				<TfiAngleLeft />
			</div>
			<div className="menu-wrapper">
				<div className="side-menu">
					<AiFillHome />
					<a href="/">Ana Ekran</a>
				</div>
				<div className="side-menu">
					<FaUsers />
					<a href={"/user-list"}>Üyeler</a>
				</div>
				<div className="side-menu">
					<FaWifi />
					<a href={"/devices"}>Cihazlar</a>
				</div>
				<div className="side-menu">
					<AiFillProduct />
					<a href={"/producers"}>Üreticiler</a>
				</div>
				<div className="side-menu">
					<FaBuilding />
					<a href={"/organizations"}>Kurumlar</a>
				</div>
				<div className="side-menu">
					<IoMdNotifications />
					<a href={"/notification-center"}>Bildirim Merkezi</a>
				</div>
				<div className="side-menu">
					<IoSettings />
					<a href="/login-detail">Ayarlar</a>
				</div>
				<div className="side-menu">
					<IoLogOutSharp />
					<p>Çıkış Yap</p>
				</div>
				<div className="side-menu">
					<BiSolidHelpCircle />
					<a href="#">Yardım</a>
				</div>
			</div>
		</div>
	);
};

export default Sidebar;
